import React, { useState } from 'react'
import { Row, Col, Image, Button, Form, Modal } from 'react-bootstrap';
import HeaderComponent from '../../Shared/HeaderComponent/Header'
import CallCustomerIcon from '../../../assets/images/Icons/PhoneIcon.svg'
import VideoCallSupportIcon from '../../../assets/images/Icons/VideoIcon.svg'
import ChatSupportIcon from '../../../assets/images/Icons/ChatIcon.svg'
import NoProfileImage from '../../../assets/images/no-profile-img.png';
import { PhoneCall, Video, MessageSquare, X, Phone } from 'lucide-react';
import Modalpopup from '../../Shared/Modals/Modal';
import './CustomerSupport.css'
import { ReactSlackChat } from 'react-slack-chat';
import Toaster from '../../../components/Shared/Toaster/Toaster';
import axios from 'axios';
import ErrorBoundary from '../../Shared/ErrorBoundary';
import PageBodyWrapper from '../../Shared/common/components/LayoutComponents/PageBodyWrapper';
import PageContentWrapper from '../../Shared/common/components/LayoutComponents/PageContentWrapper';
import TextAreaField from '../../Shared/common/components/Shared_FormControls/TextAreaField/TextAreaField';

const Customersupport = (props) => {

    const [isRedirect, setIsRedirect] = useState(false);
    const [showChat, setHelpChat] = useState(false);
    const [validated, setValidation] = useState(false);
    const [message, setMessage] = useState('');
    const [toasterInfo, setToaster] = useState({
        showToaster: false,
        content: '',
        header: '',
        class: ''
    });
    const [showModal, setModalStatus] = useState(false);

    const showModalPopup = (status) => {

        setModalStatus(status);

    }


    const onChangeField = (value) => {
        setMessage(value);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setValidation(true);
        const userDetails = JSON.parse(localStorage.getItem('user'));
        const req = {
            email: userDetails.email,
            tags: ["Dealer Questions or Comments"],
            customField: {
                'dealer_message': message
            }
        }
        const form = event.currentTarget;
        if (form.checkValidity() !== false) {


            const leadbadge_token = 'bb034b2e-9654-4e1c-a008-6518b06c14d5';

            axios.post('https://rest.gohighlevel.com/v1/contacts/', req, {
                headers: {
                    'Authorization': `Bearer ${leadbadge_token}`
                }
            })
                .then((response) => {
                    if (response.status === 200) {
                        setToaster({
                            header: 'Success',
                            class: 'success-toaster',
                            content: 'Your request sent successfully.',
                            showToaster: true
                        });
                        setMessage('');
                        setValidation(false);
                    }
                    else {
                        setToaster({
                            header: 'Error',
                            class: 'error-toaster',
                            content: 'Error while sending your request.',
                            showToaster: true
                        })

                    }

                })



        }
    }

    const toasterClose = () => {

        setToaster({
            showToaster: false,
            content: '',
            header: '',
            class: ''
        })

    }

    const userDetails = JSON.parse(localStorage.getItem('user'));

    return (
        <React.Fragment>
            <PageBodyWrapper>
                <div className="customerSupportPage">
                    {toasterInfo.showToaster ?
                        <Toaster myClassName={toasterInfo.class} onClose={toasterClose} header={toasterInfo.header} content={toasterInfo.content}></Toaster>
                        : null}
                    {props.showHeader ? <ErrorBoundary showContent={false}><HeaderComponent ddrCart={props.drawdownrequestCart} paymentsCart={props.paymentsCart} notifications={props.notifications} readNotifications={props.readNotifications} /></ErrorBoundary> : null}
                    <PageContentWrapper>
                        <Row className="first-row mt-2">
                            {
                                props.menu.length > 0 && props.menu.filter(item => item.name === 'Call Customer Support').length > 0 ?
                                    (
                                        <Col className='mb-4'>
                                            <div className="customerCareServices">
                                                <div className='customerCareService'>
                                                    <Image src={CallCustomerIcon} alt="call-customer-support-icon" />
                                                </div>
                                                <span className="customerSupport-text secondary-text-color">Call Customer Support</span>
                                                <span className='customerSupport-value'>(404) 383-7048</span>
                                                <Button href="tel:404-383-7048" className="default-btn" variant="primary">Call us</Button>
                                            </div>
                                        </Col>
                                    ) : null
                            }
                            {
                                props.menu.length > 0 && props.menu.filter(item => item.name === 'Schedule a Video Call').length > 0 ?
                                    (
                                        <Col className='mb-4'>
                                            <div className=" customerCareServices">
                                                <div className='customerCareService'>
                                                    <Image src={VideoCallSupportIcon} alt="call-customer-support-icon img-fluid" />
                                                </div>
                                                <span className="customerSupport-text secondary-text-color">Schedule a Video Call</span>
                                                <span className='customerSupport-value'> Schedule</span>
                                                <Button onClick={() => { showModalPopup(true) }} className="default-btn" variant="primary">Schedule a Call</Button>
                                            </div>
                                        </Col>
                                    ) : null
                            }
                            {
                                props.menu.length > 0 && props.menu.filter(item => item.name === 'Quick Chat with Customer Support').length > 0 ?
                                    (
                                        <Col className='mb-4'>
                                            <div className="customerCareServices">
                                                <div className='customerCareService'>
                                                    <Image src={ChatSupportIcon} alt="call-customer-support-icon img-fluid" />
                                                </div>
                                                <span className="customerSupport-text secondary-text-color">Quick Chat with Customer Support</span>
                                                <span className='customerSupport-value'> Chat</span>
                                                <Button onClick={() => setHelpChat(true)} className="default-btn" variant="primary">Chat Now</Button>
                                            </div>
                                        </Col>
                                    ) : null
                            }
                        </Row>
                        {props.menu.length > 0 && props.menu.filter(item => item.name === 'Contact Us' && item.visible === 1).length > 0 ?

                            <Row className='first-row'>
                                <Col>
                                    <div className="customer-contactUs-wrapper">
                                        <h6 >Contact Us </h6>
                                        {/* <h2 class="widget-title-color widget-title">Contact Us </h2> */}
                                        {/* <p className="content-secondary-text mb-2 progress-label-color">Submit your question/comment</p> */}
                                        <div>
                                            <Form
                                                noValidate
                                                validated={validated}
                                                onSubmit={handleSubmit}
                                            >
                                                <Form.Group controlId="exampleForm.ControlTextarea1">
                                                    <TextAreaField
                                                        label='Submit your question/comment'
                                                        as="textarea"
                                                        name="Message"
                                                        value={message}
                                                        object="message"
                                                        onChange={(key, value) => onChangeField(value)}
                                                        rows={3}
                                                        placeholder="Enter Your Message"
                                                        required
                                                    />
                                                    {/* <Form.Control.Feedback type="invalid">
                                                        Please enter message.
                                                    </Form.Control.Feedback> */}
                                                </Form.Group>

                                                <Button type="submit" className="default-btn mr-4" variant="primary">Submit</Button>
                                                <Button onClick={() => setMessage('')} variant="outline-secondary" className="default-btn">Cancel</Button>
                                            </Form>
                                        </div>
                                    </div>
                                </Col>
                            </Row> : null
                        }
                    </PageContentWrapper>
                </div>
            </PageBodyWrapper>
            {showChat ?
                <ReactSlackChat
                    botName={userDetails.email}// VisitorID, CorpID, Email, IP address etc.
                    apiToken='eG94Yi0xMzIyMzQ1ODUzNDExLTIwMzQxNjg1ODQ0MDUtS3pUSzRxNGFLM0E0ZkowQm13bm5ubkpw'
                    channels={[

                        {
                            id: 'C021SGKL0KT',
                            name: 'Help Desk',
                        },

                    ]}

                    fileUploadLoader={false}
                    singleUserMode={true}
                    helpText='Chat With Us'
                    defaultMessage='Thank you for contacting Lever. A live representative will be joining the chat momentarily to assist you.'
                    themeColor='#856090'
                    userImage={userDetails && userDetails.logo ? userDetails.logo : NoProfileImage}
                    debugMode={true}
                    hooks={[
                        {
                            /* My Custom Hook */
                            id: 'getSystemInfo',
                            action: () => Promise.resolve('MY SYSTEM INFO!')
                        }
                    ]}

                />
                : ''}
            <Modal className={`default-large-popup default-popup modal-backdrop-bg-color pr-0 scheduleCall`} show={showModal}
                onHide={() => showModalPopup(false)} backdrop={props.isStatic ? "static" : null} centered={props.centered}>
                <Modal.Header className='darkblue-bg-color' closeButton={props.isStatic ? false : true}>
                    <Modal.Title>
                        {props.icon ? props.icon : <span className='popup-title-icon'><Phone /></span>}
                        <span className='flex-grow-1'>{props.modalTitle ? props.modalTitle : 'Schedule Call'}</span>
                        <span className='popup-close-icon'><X size={20} /></span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pl-3 pr-3">
                    {/* <ResponsiveEmbed aspectRatio="21by9" width="100%">
                        <embed src="https://api.leadbadge.com/widget/appointment/service/videocall?group=verosupport&first_name=John&last_name=Mizzi&phone=9032999216&email=dealer@techvedhas.com" />
                    </ResponsiveEmbed> */}
                    <iframe width="100%" height="100%" src={"https://api.leadbadge.com/widget/appointment/service/videocall?group=verosupport&email=" + userDetails.email}></iframe>
                </Modal.Body>
            </Modal>
            {/* <Modalpopup myClassName={'full-width-popup  schedule-calendarpopup'} onClose={() => showModalPopup(false)} showModal={showModal} >

            </Modalpopup> */}
        </React.Fragment>
    )
}

export default Customersupport;